// // src/Pages/FeedbackPage.jsx
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import './FeedbackPage.css';

// export default function FeedbackPage() {
//   const [feedbacks, setFeedbacks] = useState([]);

//   useEffect(() => {
//     axios.get('http://localhost:4001/feedbacks')
//       .then(res => setFeedbacks(res.data))
//       .catch(console.error);
//   }, []);

//   return (
//     <div className="feedback-page">
//       <h1>What Our Customers Say</h1>
//       <div className="feedback-grid">
//         {feedbacks.map((f, i) => (
//           <div className="feedback-card" key={i}>
//             <div className="stars">
//               {'★'.repeat(Math.round(f.rating))}{'☆'.repeat(5 - Math.round(f.rating))}
//             </div>
//             <p className="feedback-text">“{f.feedback}”</p>
//             <div className="meta">
//               <span className="service">{f.serviceType}</span>
//               <span className="date">
//                 {new Date(f.transactionDate).toLocaleDateString()}
//               </span>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// import React, { useState, useEffect } from 'react';
// import './FeedbackPage.css';

// const FeedbackPage = ({ feedbacks = [] }) => {
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [slidesPerView, setSlidesPerView] = useState(1);

//   // Sample testimonials data (replace with props if needed)
//   const defaultTestimonials = [
//     {
//       id: 1,
//       name: "Sarah Johnson",
//       service: "Electrician",
//       provider: "Mike Thompson",
//       rating: 5,
//       feedback: "Outstanding electrical work! Mike was professional, punctual, and solved our complex wiring issue quickly. Highly recommend HelpNao for finding reliable electricians.",
//       transactionDate: "2024-01-15",
//       location: "New York, NY"
//     },
//     {
//       id: 2,
//       name: "David Chen",
//       service: "Plumber",
//       provider: "Lisa Rodriguez",
//       rating: 5,
//       feedback: "Lisa did an amazing job fixing our bathroom leak. She explained everything clearly and the pricing was very fair. Will definitely use HelpNao again!",
//       transactionDate: "2024-01-10",
//       location: "Los Angeles, CA"
//     },
//     {
//       id: 3,
//       name: "Emily Davis",
//       service: "Home Cleaning",
//       provider: "Clean Team Pro",
//       rating: 4,
//       feedback: "Excellent house cleaning service! The team was thorough and left our home spotless. Very professional and trustworthy. Thanks to HelpNao for the perfect match!",
//       transactionDate: "2024-01-12",
//       location: "Chicago, IL"
//     },
//     {
//       id: 4,
//       name: "Robert Wilson",
//       service: "Repair Service",
//       provider: "Fix-It Solutions",
//       rating: 5,
//       feedback: "Incredible repair work on our kitchen appliances. Fast, efficient, and cost-effective. The technician was knowledgeable and friendly. HelpNao made finding help so easy!",
//       transactionDate: "2024-01-08",
//       location: "Miami, FL"
//     },
//     {
//       id: 5,
//       name: "Maria Garcia",
//       service: "Electrician",
//       provider: "PowerTech Services",
//       rating: 5,
//       feedback: "Fantastic experience! They installed new outlets and lighting fixtures perfectly. Clean work, reasonable prices, and excellent customer service through HelpNao.",
//       transactionDate: "2024-01-05",
//       location: "Houston, TX"
//     },
//     {
//       id: 6,
//       name: "James Anderson",
//       service: "Plumber",
//       provider: "AquaFix Pro",
//       rating: 4,
//       feedback: "Great plumbing service for our emergency pipe burst. Quick response time and professional work. The pricing was transparent and fair. Highly recommend!",
//       transactionDate: "2024-01-03",
//       location: "Phoenix, AZ"
//     }
//   ];

//   const testimonials = feedbacks.length > 0 ? feedbacks : defaultTestimonials;

//   // Generate avatar based on name
//   const generateAvatar = (name) => {
//     const canvas = document.createElement('canvas');
//     canvas.width = 60;
//     canvas.height = 60;
//     const ctx = canvas.getContext('2d');

//     const colors = ['#60f549', '#3b82f6', '#8b5cf6', '#f59e0b', '#ef4444', '#06b6d4'];
//     const colorIndex = name.length % colors.length;
//     ctx.fillStyle = colors[colorIndex];
//     ctx.fillRect(0, 0, 60, 60);

//     ctx.fillStyle = 'white';
//     ctx.font = 'bold 20px Arial';
//     ctx.textAlign = 'center';
//     ctx.textBaseline = 'middle';
//     ctx.fillText(name.split(' ').map(n => n[0]).join(''), 30, 30);

//     return canvas.toDataURL();
//   };

//   // Generate stars
//   const generateStars = (rating) => {
//     const stars = [];
//     for (let i = 1; i <= 5; i++) {
//       if (i <= rating) {
//         stars.push(<i key={i} className="fas fa-star feedbackpage-star-filled"></i>);
//       } else {
//         stars.push(<i key={i} className="far fa-star feedbackpage-star-empty"></i>);
//       }
//     }
//     return stars;
//   };

//   // Get service color
//   const getServiceColor = (service) => {
//     const colors = {
//       'Electrician': 'feedbackpage-service-electrician',
//       'Plumber': 'feedbackpage-service-plumber',
//       'Home Cleaning': 'feedbackpage-service-cleaning',
//       'Repair Service': 'feedbackpage-service-repair'
//     };
//     return colors[service] || 'feedbackpage-service-default';
//   };

//   // Format date
//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     const now = new Date();
//     const diffTime = Math.abs(now - date);
//     const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

//     if (diffDays === 1) return '1 day ago';
//     if (diffDays < 7) return `${diffDays} days ago`;
//     if (diffDays < 14) return '1 week ago';
//     if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
//     return date.toLocaleDateString();
//   };

//   // Update slides per view based on screen size
//   const updateSlidesPerView = () => {
//     if (window.innerWidth >= 1024) {
//       setSlidesPerView(3);
//     } else if (window.innerWidth >= 768) {
//       setSlidesPerView(2);
//     } else {
//       setSlidesPerView(1);
//     }
//   };

//   useEffect(() => {
//     updateSlidesPerView();
//     window.addEventListener('resize', updateSlidesPerView);
//     return () => window.removeEventListener('resize', updateSlidesPerView);
//   }, []);

//   // Auto-play functionality
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentSlide((prev) => {
//         if (prev < testimonials.length - slidesPerView) {
//           return prev + 1;
//         } else {
//           return 0;
//         }
//       });
//     }, 5000);

//     return () => clearInterval(interval);
//   }, [testimonials.length, slidesPerView]);

//   const nextSlide = () => {
//     if (currentSlide < testimonials.length - slidesPerView) {
//       setCurrentSlide(currentSlide + 1);
//     }
//   };

//   const prevSlide = () => {
//     if (currentSlide > 0) {
//       setCurrentSlide(currentSlide - 1);
//     }
//   };

//   const goToSlide = (index) => {
//     setCurrentSlide(index * slidesPerView);
//   };

//   const totalDots = Math.ceil(testimonials.length / slidesPerView);

//   return (
//     <section className="feedbackpage-section">
//       <div className="feedbackpage-container">
//         {/* Section Header */}
//         <div className="feedbackpage-section-header">
//           <h2 className="feedbackpage-section-title">What Our Customers Say</h2>
//           <p className="feedbackpage-section-description">
//             Real feedback from real customers who experienced our professional services.
//             Your satisfaction is our priority.
//           </p>
//         </div>

//         {/* Testimonials Slider */}
//         <div className="feedbackpage-testimonial-slider">
//           <div
//             className="feedbackpage-testimonial-track"
//             style={{
//               transform: `translateX(-${currentSlide * (100 / slidesPerView)}%)`
//             }}
//           >
//             {testimonials.map((testimonial, index) => (
//               <div key={testimonial.id || index} className="feedbackpage-testimonial-slide">
//                 <div className="feedbackpage-testimonial-card">
//                   {/* Header with user info */}
//                   <div className="feedbackpage-testimonial-header">
//                     <img
//                       src={generateAvatar(testimonial.name)}
//                       alt={testimonial.name}
//                       className="feedbackpage-user-avatar"
//                     />
//                     <div className="feedbackpage-user-info">
//                       <div className="feedbackpage-user-name-wrapper">
//                         <h4 className="feedbackpage-user-name">{testimonial.name}</h4>
//                         <i className="fas fa-check-circle feedbackpage-verified-icon"></i>
//                       </div>
//                       {testimonial.location && (
//                         <div className="feedbackpage-user-location">{testimonial.location}</div>
//                       )}
//                       <div className="feedbackpage-rating-wrapper">
//                         <div className="feedbackpage-stars">{generateStars(testimonial.rating)}</div>
//                         <span className="feedbackpage-review-date">
//                           {formatDate(testimonial.transactionDate)}
//                         </span>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Review text */}
//                   <p className="feedbackpage-feedback-text">"{testimonial.feedback}"</p>

//                   {/* Service and provider info */}
//                   <div className="feedbackpage-testimonial-footer">
//                     <div className="feedbackpage-provider-info">
//                       <div className={`feedbackpage-service-icon ${getServiceColor(testimonial.service || testimonial.serviceType)}`}>
//                         <i className="fas fa-check"></i>
//                       </div>
//                       <div className="feedbackpage-provider-details">
//                         <div className="feedbackpage-provider-name">{testimonial.provider || 'Service Provider'}</div>
//                         <div className="feedbackpage-service-type">{testimonial.service || testimonial.serviceType}</div>
//                       </div>
//                     </div>
//                     <div className="feedbackpage-rating-score">
//                       <div className="feedbackpage-score">{testimonial.rating}.0</div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Navigation Arrows */}
//           <button
//             className="feedbackpage-nav-arrow feedbackpage-prev-arrow"
//             onClick={prevSlide}
//             disabled={currentSlide === 0}
//           >
//             <i className="fas fa-chevron-left"></i>
//           </button>
//           <button
//             className="feedbackpage-nav-arrow feedbackpage-next-arrow"
//             onClick={nextSlide}
//             disabled={currentSlide >= testimonials.length - slidesPerView}
//           >
//             <i className="fas fa-chevron-right"></i>
//           </button>
//         </div>

//         {/* Slider Dots */}
//         <div className="feedbackpage-slider-dots">
//           {Array.from({ length: totalDots }, (_, index) => (
//             <button
//               key={index}
//               className={`feedbackpage-slider-dot ${Math.floor(currentSlide / slidesPerView) === index ? 'feedbackpage-active' : ''}`}
//               onClick={() => goToSlide(index)}
//             />
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FeedbackPage;

// ***** Make Dyanmic Feedback ***** //
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import './FeedbackPage.css';

// const FeedbackPage = () => {
//   const [testimonials, setTestimonials] = useState([]);
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [slidesPerView, setSlidesPerView] = useState(1);

//   // 1) Fetch live feedbacks
//   useEffect(() => {
//     axios.get('http://localhost:4001/feedbacks')
//       .then(res => setTestimonials(res.data))
//       .catch(err => console.error('Error fetching feedbacks:', err));
//   }, []);

//   // 2) Responsive slides-per-view
//   const updateSlidesPerView = () => {
//     if (window.innerWidth >= 1024)       setSlidesPerView(3);
//     else if (window.innerWidth >= 768)   setSlidesPerView(2);
//     else                                  setSlidesPerView(1);
//   };
//   useEffect(() => {
//     updateSlidesPerView();
//     window.addEventListener('resize', updateSlidesPerView);
//     return () => window.removeEventListener('resize', updateSlidesPerView);
//   }, []);

//   // 3) Auto-play
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentSlide(prev =>
//         prev < testimonials.length - slidesPerView ? prev + 1 : 0
//       );
//     }, 5000);
//     return () => clearInterval(interval);
//   }, [testimonials.length, slidesPerView]);

//   // Helpers -----------------------------------------------------

//   const generateAvatar = name => {
//     const canvas = document.createElement('canvas');
//     canvas.width = canvas.height = 60;
//     const ctx = canvas.getContext('2d');
//     const colors = ['#60f549','#3b82f6','#8b5cf6','#f59e0b','#ef4444','#06b6d4'];
//     ctx.fillStyle = colors[name.length % colors.length];
//     ctx.fillRect(0,0,60,60);
//     ctx.fillStyle = 'white';
//     ctx.font = 'bold 20px Arial';
//     ctx.textAlign = 'center';
//     ctx.textBaseline = 'middle';
//     const initials = name.split(' ').map(n=>n[0]).join('');
//     ctx.fillText(initials,30,30);
//     return canvas.toDataURL();
//   };

//   const generateStars = rating => {
//     const stars = [];
//     for (let i=1; i<=5; i++) {
//       stars.push(
//         i <= rating
//           ? <i key={i} className="fas fa-star feedbackpage-star-filled"></i>
//           : <i key={i} className="far fa-star feedbackpage-star-empty"></i>
//       );
//     }
//     return stars;
//   };

//   const getServiceColor = svc => {
//     const m = {
//       'Electrician':    'feedbackpage-service-electrician',
//       'Plumber':        'feedbackpage-service-plumber',
//       'Home Cleaning':  'feedbackpage-service-cleaning',
//     };
//     return m[svc] || 'feedbackpage-service-default';
//   };

//   const formatDate = dateString => {
//     const date = new Date(dateString), now = Date.now();
//     const diffDays = Math.floor((now - date)/ (1000*60*60*24));
//     if (diffDays === 0) return 'Today';
//     if (diffDays === 1) return '1 day ago';
//     if (diffDays < 7)  return `${diffDays} days ago`;
//     if (diffDays < 14) return '1 week ago';
//     return date.toLocaleDateString();
//   };

//   const nextSlide = () =>
//     setCurrentSlide(s => Math.min(s+1, testimonials.length - slidesPerView));
//   const prevSlide = () =>
//     setCurrentSlide(s => Math.max(s-1, 0));
//   const goToSlide = idx =>
//     setCurrentSlide(idx * slidesPerView);

//   const totalDots = Math.ceil(testimonials.length / slidesPerView);

//   // -------------------------------------------------------------

//   return (
//     <section className="feedbackpage-section">
//       <div className="feedbackpage-container">

//         {/* Header */}
//         <div className="feedbackpage-section-header">
//           <h2 className="feedbackpage-section-title">What Our Customers Say</h2>
//           <p className="feedbackpage-section-description">
//             Real feedback from real customers who experienced our professional services.
//             Your satisfaction is our priority.
//           </p>
//         </div>

//         {/* Slider */}
//         <div className="feedbackpage-testimonial-slider">
//           <div
//             className="feedbackpage-testimonial-track"
//             style={{ transform: `translateX(-${currentSlide * (100/slidesPerView)}%)` }}
//           >
//             {testimonials.map((t, i) => {
//               const customerName = `${t.User?.FirstName || ''} ${t.User?.LastName || ''}`.trim() || 'Anonymous';
//               const providerName = t.Servitor
//                 ? `${t.Servitor.FirstName} ${t.Servitor.LastName}`
//                 : 'Service Provider';
//               const serviceName = t.Services?.services_name || t.serviceType || 'Service';

//               return (
//                 <div key={i} className="feedbackpage-testimonial-slide">
//                   <div className="feedbackpage-testimonial-card">

//                     {/* User Info */}
//                     <div className="feedbackpage-testimonial-header">
//                       <img
//                         src={generateAvatar(customerName)}
//                         alt={customerName}
//                         className="feedbackpage-user-avatar"
//                       />
//                       <div className="feedbackpage-user-info">
//                         <div className="feedbackpage-user-name-wrapper">
//                           <h4 className="feedbackpage-user-name">{customerName}</h4>
//                           <i className="fas fa-check-circle feedbackpage-verified-icon"></i>
//                         </div>
//                         {t.User?.city && (
//                           <div className="feedbackpage-user-location">{t.User.city}</div>
//                         )}
//                         <div className="feedbackpage-rating-wrapper">
//                           <div className="feedbackpage-stars">
//                             {generateStars(t.rating)}
//                           </div>
//                           <span className="feedbackpage-review-date">
//                             {formatDate(t.transactionDate)}
//                           </span>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Feedback Text */}
//                     <p className="feedbackpage-feedback-text">
//                       "{t.feedback}"
//                     </p>

//                     {/* Provider & Service */}
//                     <div className="feedbackpage-testimonial-footer">
//                       <div className="feedbackpage-provider-info">
//                         <div
//                           className={`feedbackpage-service-icon ${getServiceColor(serviceName)}`}
//                         >
//                           <i className="fas fa-check"></i>
//                         </div>
//                         <div className="feedbackpage-provider-details">
//                           <div className="feedbackpage-provider-name">
//                             {providerName}
//                           </div>
//                           <div className="feedbackpage-service-type">
//                             {serviceName}
//                           </div>
//                         </div>
//                       </div>
//                       <div className="feedbackpage-rating-score">
//                         <div className="feedbackpage-score">{t.rating.toFixed(1)}</div>
//                       </div>
//                     </div>

//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           {/* Nav Arrows */}
//           <button
//             className="feedbackpage-nav-arrow feedbackpage-prev-arrow"
//             onClick={prevSlide}
//             disabled={currentSlide === 0}
//           >
//             <i className="fas fa-chevron-left"></i>
//           </button>
//           <button
//             className="feedbackpage-nav-arrow feedbackpage-next-arrow"
//             onClick={nextSlide}
//             disabled={currentSlide >= testimonials.length - slidesPerView}
//           >
//             <i className="fas fa-chevron-right"></i>
//           </button>
//         </div>

//         {/* Pagination Dots */}
//         <div className="feedbackpage-slider-dots">
//           {Array.from({ length: totalDots }).map((_, idx) => (
//             <button
//               key={idx}
//               className={`feedbackpage-slider-dot
//                 ${Math.floor(currentSlide / slidesPerView) === idx
//                   ? 'feedbackpage-active'
//                   : ''}`}
//               onClick={() => goToSlide(idx)}
//             />
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// };

// export default FeedbackPage;











// ***** Make Dynamic Feedback ***** //

// ***** This is service type feedback can set if needed ***** //

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import "./FeedbackPage.css";

// const FeedbackPage = ({ serviceType }) => {
//   const [testimonials, setTestimonials] = useState([]);
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [slidesPerView, setSlidesPerView] = useState(1);

//   // 1) Fetch live feedbacks based on serviceType
//   useEffect(() => {
//     const fetchFeedbacks = async () => {
//       try {
//         const url = serviceType
//           ? `http://localhost:4001/feedbacks?serviceType=${encodeURIComponent(
//               serviceType
//             )}`
//           : "http://localhost:4001/feedbacks";
//         const res = await axios.get(url);
//         setTestimonials(res.data);
//       } catch (err) {
//         console.error("Error fetching feedbacks:", err);
//       }
//     };
//     fetchFeedbacks();
//   }, [serviceType]);

//   // 2) Responsive slides-per-view
//   const updateSlidesPerView = () => {
//     if (window.innerWidth >= 1024) setSlidesPerView(3);
//     else if (window.innerWidth >= 768) setSlidesPerView(2);
//     else setSlidesPerView(1);
//   };
//   useEffect(() => {
//     updateSlidesPerView();
//     window.addEventListener("resize", updateSlidesPerView);
//     return () => window.removeEventListener("resize", updateSlidesPerView);
//   }, []);

//   // 3) Auto-play
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentSlide((prev) =>
//         prev < testimonials.length - slidesPerView ? prev + 1 : 0
//       );
//     }, 5000);
//     return () => clearInterval(interval);
//   }, [testimonials.length, slidesPerView]);

//   // Helpers -----------------------------------------------------

//   const generateAvatar = (name) => {
//     const canvas = document.createElement("canvas");
//     canvas.width = canvas.height = 60;
//     const ctx = canvas.getContext("2d");
//     const colors = [
//       "#60f549",
//       "#3b82f6",
//       "#8b5cf6",
//       "#f59e0b",
//       "#ef4444",
//       "#06b6d4",
//     ];
//     ctx.fillStyle = colors[name.length % colors.length];
//     ctx.fillRect(0, 0, 60, 60);
//     ctx.fillStyle = "white";
//     ctx.font = "bold 20px Arial";
//     ctx.textAlign = "center";
//     ctx.textBaseline = "middle";
//     const initials = name
//       .split(" ")
//       .map((n) => n[0])
//       .join("");
//     ctx.fillText(initials, 30, 30);
//     return canvas.toDataURL();
//   };

//   const generateStars = (rating) => {
//     const stars = [];
//     for (let i = 1; i <= 5; i++) {
//       stars.push(
//         i <= rating ? (
//           <i key={i} className="fas fa-star feedbackpage-star-filled"></i>
//         ) : (
//           <i key={i} className="far fa-star feedbackpage-star-empty"></i>
//         )
//       );
//     }
//     return stars;
//   };

//   const getServiceColor = (svc) => {
//     const m = {
//       Electrician: "feedbackpage-service-electrician",
//       Plumber: "feedbackpage-service-plumber",
//       "Home Cleaning": "feedbackpage-service-cleaning",
//     };
//     return m[svc] || "feedbackpage-service-default";
//   };

//   const formatDate = (dateString) => {
//     const date = new Date(dateString),
//       now = Date.now();
//     const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));
//     if (diffDays === 0) return "Today";
//     if (diffDays === 1) return "1 day ago";
//     if (diffDays < 7) return `${diffDays} days ago`;
//     if (diffDays < 14) return "1 week ago";
//     return date.toLocaleDateString();
//   };

//   const nextSlide = () =>
//     setCurrentSlide((s) =>
//       Math.min(s + 1, testimonials.length - slidesPerView)
//     );
//   const prevSlide = () => setCurrentSlide((s) => Math.max(s - 1, 0));
//   const goToSlide = (idx) => setCurrentSlide(idx * slidesPerView);

//   const totalDots = Math.ceil(testimonials.length / slidesPerView);

//   // Header customization based on serviceType
//   const getHeaderTitle = () => {
//     if (serviceType === "Electrician") return "Electrician Feedback";
//     if (serviceType === "Plumber") return "Plumber Feedback";
//     if (serviceType === "Home Cleaning") return "Home Cleaning Feedback";
//     return "What Our Customers Say";
//   };

//   const getHeaderDescription = () => {
//     if (serviceType) {
//       return `Real feedback from customers who experienced our ${serviceType} services. Your satisfaction is our priority.`;
//     }
//     return "Real feedback from real customers who experienced our professional services. Your satisfaction is our priority.";
//   };

//   return (
//     <section className="feedbackpage-section">
//       <div className="feedbackpage-container">
//         {/* Header */}
//         <div className="feedbackpage-section-header">
//           <h2 className="feedbackpage-section-title">{getHeaderTitle()}</h2>
//           <p className="feedbackpage-section-description">
//             {getHeaderDescription()}
//           </p>
//         </div>

//         {/* Slider */}
//         <div className="feedbackpage-testimonial-slider">
//           <div
//             className="feedbackpage-testimonial-track"
//             style={{
//               transform: `translateX(-${
//                 currentSlide * (100 / slidesPerView)
//               }%)`,
//             }}
//           >
//             {testimonials.map((t, i) => {
//               const customerName =
//                 `${t.User?.FirstName || ""} ${t.User?.LastName || ""}`.trim() ||
//                 "Anonymous";
//               const providerName = t.Servitor
//                 ? `${t.Servitor.FirstName} ${t.Servitor.LastName}`
//                 : "Service Provider";
//               const serviceName =
//                 t.Services?.services_name || t.serviceType || "Service";

//               return (
//                 <div key={i} className="feedbackpage-testimonial-slide">
//                   <div className="feedbackpage-testimonial-card">
//                     {/* User Info */}
//                     <div className="feedbackpage-testimonial-header">
//                       <img
//                         src={generateAvatar(customerName)}
//                         alt={customerName}
//                         className="feedbackpage-user-avatar"
//                       />
//                       <div className="feedbackpage-user-info">
//                         <div className="feedbackpage-user-name-wrapper">
//                           <h4 className="feedbackpage-user-name">
//                             {customerName}
//                           </h4>
//                           <i className="fas fa-check-circle feedbackpage-verified-icon"></i>
//                         </div>
//                         {t.User?.city && (
//                           <div className="feedbackpage-user-location">
//                             {t.User.city}
//                           </div>
//                         )}
//                         <div className="feedbackpage-rating-wrapper">
//                           <div className="feedbackpage-stars">
//                             {generateStars(t.rating)}
//                           </div>
//                         </div>
//                         <div className="feedbackpage-review-date">
//                           {formatDate(t.transactionDate)}
//                         </div>
//                       </div>
//                     </div>

//                     {/* Feedback Text */}
//                     <p className="feedbackpage-feedback-text">"{t.feedback}"</p>

//                     {/* Provider & Service */}
//                     <div className="feedbackpage-testimonial-footer">
//                       <div className="feedbackpage-provider-info">
//                         <div
//                           className={`feedbackpage-service-icon ${getServiceColor(
//                             serviceName
//                           )}`}
//                         >
//                           <i className="fas fa-check"></i>
//                         </div>
//                         <div className="feedbackpage-provider-details">
//                           <div className="feedbackpage-provider-name">
//                             {providerName}
//                           </div>
//                           <div className="feedbackpage-service-type">
//                             {serviceName}
//                           </div>
//                         </div>
//                       </div>
//                       <div className="feedbackpage-rating-score">
//                         <div className="feedbackpage-score">
//                           {t.rating.toFixed(1)}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           {/* Nav Arrows */}
//           <button
//             className="feedbackpage-nav-arrow feedbackpage-prev-arrow"
//             onClick={prevSlide}
//             disabled={currentSlide === 0}
//           >
//             <i className="fas fa-chevron-left"></i>
//           </button>
//           <button
//             className="feedbackpage-nav-arrow feedbackpage-next-arrow"
//             onClick={nextSlide}
//             disabled={currentSlide >= testimonials.length - slidesPerView}
//           >
//             <i className="fas fa-chevron-right"></i>
//           </button>
//         </div>

//         {/* Pagination Dots */}
//         <div className="feedbackpage-slider-dots">
//           {Array.from({ length: totalDots }).map((_, idx) => (
//             <button
//               key={idx}
//               className={`feedbackpage-slider-dot ${
//                 Math.floor(currentSlide / slidesPerView) === idx
//                   ? "feedbackpage-active"
//                   : ""
//               }`}
//               onClick={() => goToSlide(idx)}
//             />
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FeedbackPage;


// ***** Upper all is okay checkked (13-oct-2025)







// ***** Update with URL (13-Oct-2025) ***** //

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import "./FeedbackPage.css";
// import { URL } from "../../config";
// import { useTranslation } from "react-i18next";


// const FeedbackPage = ({ serviceType }) => {
//   const { t } = useTranslation();
//   const [testimonials, setTestimonials] = useState([]);
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [slidesPerView, setSlidesPerView] = useState(1);

//   // 1) Fetch live feedbacks based on serviceType
//   useEffect(() => {
//     const fetchFeedbacks = async () => {
//       try {
//         const url = serviceType
//           ? `${URL}/feedbacks?serviceType=${encodeURIComponent(
//               serviceType
//             )}`
//           : `${URL}/feedbacks`;
//         const res = await axios.get(url);
//         setTestimonials(res.data);
//       } catch (err) {
//         console.error("Error fetching feedbacks:", err);
//       }
//     };
//     fetchFeedbacks();
//   }, [serviceType]);

//   // 2) Responsive slides-per-view
//   const updateSlidesPerView = () => {
//     if (window.innerWidth >= 1024) setSlidesPerView(3);
//     else if (window.innerWidth >= 768) setSlidesPerView(2);
//     else setSlidesPerView(1);
//   };
//   useEffect(() => {
//     updateSlidesPerView();
//     window.addEventListener("resize", updateSlidesPerView);
//     return () => window.removeEventListener("resize", updateSlidesPerView);
//   }, []);

//   // 3) Auto-play
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentSlide((prev) =>
//         prev < testimonials.length - slidesPerView ? prev + 1 : 0
//       );
//     }, 5000);
//     return () => clearInterval(interval);
//   }, [testimonials.length, slidesPerView]);


//   // ✅ HIDE ENTIRE SECTION if still loading OR no feedbacks (New Added)
//   if (testimonials.length === 0) return null;

//   // Helpers -----------------------------------------------------

//   const generateAvatar = (name) => {
//     const canvas = document.createElement("canvas");
//     canvas.width = canvas.height = 60;
//     const ctx = canvas.getContext("2d");
//     const colors = [
//       "#60f549",
//       "#3b82f6",
//       "#8b5cf6",
//       "#f59e0b",
//       "#ef4444",
//       "#06b6d4",
//     ];
//     ctx.fillStyle = colors[name.length % colors.length];
//     ctx.fillRect(0, 0, 60, 60);
//     ctx.fillStyle = "white";
//     ctx.font = "bold 20px Arial";
//     ctx.textAlign = "center";
//     ctx.textBaseline = "middle";
//     const initials = name
//       .split(" ")
//       .map((n) => n[0])
//       .join("");
//     ctx.fillText(initials, 30, 30);
//     return canvas.toDataURL();
//   };

//   const generateStars = (rating) => {
//     const stars = [];
//     for (let i = 1; i <= 5; i++) {
//       stars.push(
//         i <= rating ? (
//           <i key={i} className="fas fa-star feedbackpage-star-filled"></i>
//         ) : (
//           <i key={i} className="far fa-star feedbackpage-star-empty"></i>
//         )
//       );
//     }
//     return stars;
//   };

//   const getServiceColor = (svc) => {
//     const m = {
//       Electrician: "feedbackpage-service-electrician",
//       Plumber: "feedbackpage-service-plumber",
//       "Home Cleaning": "feedbackpage-service-cleaning",
//     };
//     return m[svc] || "feedbackpage-service-default";
//   };

//   const formatDate = (dateString) => {
//     const date = new Date(dateString),
//       now = Date.now();
//     const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));
//     if (diffDays === 0) return "Today";
//     if (diffDays === 1) return "1 day ago";
//     if (diffDays < 7) return `${diffDays} days ago`;
//     if (diffDays < 14) return "1 week ago";
//     return date.toLocaleDateString();
//   };

//   const nextSlide = () =>
//     setCurrentSlide((s) =>
//       Math.min(s + 1, testimonials.length - slidesPerView)
//     );
//   const prevSlide = () => setCurrentSlide((s) => Math.max(s - 1, 0));
//   const goToSlide = (idx) => setCurrentSlide(idx * slidesPerView);

//   const totalDots = Math.ceil(testimonials.length / slidesPerView);

//   // Header customization based on serviceType
//   // const getHeaderTitle = () => {
//   //   if (serviceType === "Electrician") return "Electrician Feedback";
//   //   if (serviceType === "Plumber") return "Plumber Feedback";
//   //   if (serviceType === "Home Cleaning") return "Home Cleaning Feedback";
//   //   return "What Our Customers Say";
//   // };

//   // const getHeaderDescription = () => {
//   //   if (serviceType) {
//   //     return `Real feedback from customers who experienced our ${serviceType} services. Your satisfaction is our priority.`;
//   //   }
//   //   return "Real feedback from real customers who experienced our professional services. Your satisfaction is our priority.";
//   // };

//   const getHeaderTitle = () => {
//     if (serviceType === "Electrician")
//       return t("feedback.header.title.electrician");

//     if (serviceType === "Plumber")
//       return t("feedback.header.title.plumber");

//     if (serviceType === "Home Cleaning")
//       return t("feedback.header.title.home_cleaning");

//     return t("feedback.header.title.default");
//   };

//   const getHeaderDescription = () => {
//     if (serviceType) {
//       return t("feedback.header.description.withService", {
//         serviceType,
//       });
//     }
//     return t("feedback.header.description.default");
//   };


//   return (
//     <section className="feedbackpage-section">
//       <div className="feedbackpage-container">
//         {/* Header */}
//         <div className="feedbackpage-section-header">
//           <h2 className="feedbackpage-section-title">{getHeaderTitle()}</h2>
//           <p className="feedbackpage-section-description">
//             {getHeaderDescription()}
//           </p>
//         </div>

//         {/* Slider */}
//         <div className="feedbackpage-testimonial-slider">
//           <div
//             className="feedbackpage-testimonial-track"
//             style={{
//               transform: `translateX(-${
//                 currentSlide * (100 / slidesPerView)
//               }%)`,
//             }}
//           >
//             {testimonials.map((t, i) => {
//               const customerName =
//                 `${t.User?.FirstName || ""} ${t.User?.LastName || ""}`.trim() ||
//                 "Anonymous";
//               const providerName = t.Servitor
//                 ? `${t.Servitor.FirstName} ${t.Servitor.LastName}`
//                 : "Service Provider";
//               const serviceName =
//                 t.Services?.services_name || t.serviceType || "Service";

//               return (
//                 <div key={i} className="feedbackpage-testimonial-slide">
//                   <div className="feedbackpage-testimonial-card">
//                     {/* User Info */}
//                     <div className="feedbackpage-testimonial-header">
//                       <img
//                         src={generateAvatar(customerName)}
//                         alt={customerName}
//                         className="feedbackpage-user-avatar"
//                       />
//                       <div className="feedbackpage-user-info">
//                         <div className="feedbackpage-user-name-wrapper">
//                           <h4 className="feedbackpage-user-name">
//                             {customerName}
//                           </h4>
//                           <i className="fas fa-check-circle feedbackpage-verified-icon"></i>
//                         </div>
//                         {t.User?.city && (
//                           <div className="feedbackpage-user-location">
//                             {t.User.city}
//                           </div>
//                         )}
//                         <div className="feedbackpage-rating-wrapper">
//                           <div className="feedbackpage-stars">
//                             {generateStars(t.rating)}
//                           </div>
//                         </div>
//                         <div className="feedbackpage-review-date">
//                           {formatDate(t.transactionDate)}
//                         </div>
//                       </div>
//                     </div>

//                     {/* Feedback Text */}
//                     <p className="feedbackpage-feedback-text">"{t.feedback}"</p>

//                     {/* Provider & Service */}
//                     <div className="feedbackpage-testimonial-footer">
//                       <div className="feedbackpage-provider-info">
//                         <div
//                           className={`feedbackpage-service-icon ${getServiceColor(
//                             serviceName
//                           )}`}
//                         >
//                           <i className="fas fa-check"></i>
//                         </div>
//                         <div className="feedbackpage-provider-details">
//                           <div className="feedbackpage-provider-name">
//                             {providerName}
//                           </div>
//                           <div className="feedbackpage-service-type">
//                             {serviceName}
//                           </div>
//                         </div>
//                       </div>
//                       <div className="feedbackpage-rating-score">
//                         <div className="feedbackpage-score">
//                           {t.rating.toFixed(1)}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           {/* Nav Arrows */}
//           <button
//             className="feedbackpage-nav-arrow feedbackpage-prev-arrow"
//             onClick={prevSlide}
//             disabled={currentSlide === 0}
//           >
//             <i className="fas fa-chevron-left"></i>
//           </button>
//           <button
//             className="feedbackpage-nav-arrow feedbackpage-next-arrow"
//             onClick={nextSlide}
//             disabled={currentSlide >= testimonials.length - slidesPerView}
//           >
//             <i className="fas fa-chevron-right"></i>
//           </button>
//         </div>

//         {/* Pagination Dots */}
//         <div className="feedbackpage-slider-dots">
//           {Array.from({ length: totalDots }).map((_, idx) => (
//             <button
//               key={idx}
//               className={`feedbackpage-slider-dot ${
//                 Math.floor(currentSlide / slidesPerView) === idx
//                   ? "feedbackpage-active"
//                   : ""
//               }`}
//               onClick={() => goToSlide(idx)}
//             />
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FeedbackPage;



// ***** New Update (29-Dec-2025) ***** //

import React, { useState, useEffect } from "react";
import axios from "axios";
import "./FeedbackPage.css";
import { URL } from "../../config";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar as faStarSolid,
  faCheckCircle,
  faMapMarkerAlt,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faTimes,
  faClock, 
} from "@fortawesome/free-solid-svg-icons";


const FeedbackPage = ({ serviceType }) => {
  const { t } = useTranslation();
  const [testimonials, setTestimonials] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slidesPerView, setSlidesPerView] = useState(1);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTestimonial, setSelectedTestimonial] = useState(null);

  // 1) Fetch live feedbacks based on serviceType
  useEffect(() => {
    const fetchFeedbacks = async () => {
      try {
        const url = serviceType
          ? `${URL}/feedbacks?serviceType=${encodeURIComponent(
              serviceType
            )}`
          : `${URL}/feedbacks`;
        const res = await axios.get(url);
        setTestimonials(res.data);
      } catch (err) {
        console.error("Error fetching feedbacks:", err);
      }
    };
    fetchFeedbacks();
  }, [serviceType]);

  // 2) Responsive slides-per-view
  const updateSlidesPerView = () => {
    if (window.innerWidth >= 1024) setSlidesPerView(3);
    else if (window.innerWidth >= 768) setSlidesPerView(2);
    else setSlidesPerView(1);
  };
  useEffect(() => {
    updateSlidesPerView();
    window.addEventListener("resize", updateSlidesPerView);
    return () => window.removeEventListener("resize", updateSlidesPerView);
  }, []);

  // 3) Auto-play
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) =>
        prev < testimonials.length - slidesPerView ? prev + 1 : 0
      );
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonials.length, slidesPerView]);


  const openModal = (item) => {
    setSelectedTestimonial(item);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedTestimonial(null);
  };

  useEffect(() => {
    if (!isModalOpen) return;

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKeyDown = (e) => {
      if (e.key === "Escape") closeModal();
    };

    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [isModalOpen]);


  // HIDE ENTIRE SECTION if still loading OR no feedbacks (New Added)
  if (testimonials.length === 0) return null;

  // Helpers -----------------------------------------------------

  const generateAvatar = (name) => {
    const canvas = document.createElement("canvas");
    canvas.width = canvas.height = 60;
    const ctx = canvas.getContext("2d");
    const colors = [
      "#60f549",
      "#3b82f6",
      "#8b5cf6",
      "#f59e0b",
      "#ef4444",
      "#06b6d4",
    ];
    ctx.fillStyle = colors[name.length % colors.length];
    ctx.fillRect(0, 0, 60, 60);
    ctx.fillStyle = "white";
    ctx.font = "bold 20px Arial";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    const initials = name
      .split(" ")
      .map((n) => n[0])
      .join("");
    ctx.fillText(initials, 30, 30);
    return canvas.toDataURL();
  };

    const ICON = {
      starSolid: faStarSolid,
      verified: faCheckCircle,
      location: faMapMarkerAlt,
      check: faCheck,
      left: faChevronLeft,
      right: faChevronRight,
      close: faTimes,
      clock: faClock,
    };

  // const generateStars = (rating) => {
  //   const stars = [];
  //   for (let i = 1; i <= 5; i++) {
  //     stars.push(
  //       i <= rating ? (
  //         <i key={i} className="fas fa-star feedbackpage-star-filled"></i>
  //       ) : (
  //         <i key={i} className="far fa-star feedbackpage-star-empty"></i>
  //       )
  //     );
  //   }
  //   return stars;
  // };


  const generateStars = (rating) => {
    const r = Math.round(Number(rating) || 0);
    const stars = [];

    for (let i = 1; i <= 5; i++) {
      const filled = i <= r;
      stars.push(
        <FontAwesomeIcon
          key={i}
          icon={ICON.starSolid} // always solid
          className={filled ? "feedbackpage-star-filled" : "feedbackpage-star-empty"}
          aria-hidden="true"
        />
      );
    }
    return stars;
  };



  const getServiceColor = (svc) => {
    const m = {
      Electrician: "feedbackpage-service-electrician",
      Plumber: "feedbackpage-service-plumber",
      "Home Cleaning": "feedbackpage-service-cleaning",
    };
    return m[svc] || "feedbackpage-service-default";
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString),
      now = Date.now();
    const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));
    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "1 day ago";
    if (diffDays < 7) return `${diffDays} days ago`;
    if (diffDays < 14) return "1 week ago";
    return date.toLocaleDateString();
  };

  const nextSlide = () =>
    setCurrentSlide((s) =>
      Math.min(s + 1, testimonials.length - slidesPerView)
    );
  const prevSlide = () => setCurrentSlide((s) => Math.max(s - 1, 0));
  const goToSlide = (idx) => setCurrentSlide(idx * slidesPerView);

  const totalDots = Math.ceil(testimonials.length / slidesPerView);

  // Header customization based on serviceType
  // const getHeaderTitle = () => {
  //   if (serviceType === "Electrician") return "Electrician Feedback";
  //   if (serviceType === "Plumber") return "Plumber Feedback";
  //   if (serviceType === "Home Cleaning") return "Home Cleaning Feedback";
  //   return "What Our Customers Say";
  // };

  // const getHeaderDescription = () => {
  //   if (serviceType) {
  //     return `Real feedback from customers who experienced our ${serviceType} services. Your satisfaction is our priority.`;
  //   }
  //   return "Real feedback from real customers who experienced our professional services. Your satisfaction is our priority.";
  // };

  const getHeaderTitle = () => {
    if (serviceType === "Electrician")
      return t("feedback.header.title.electrician");

    if (serviceType === "Plumber")
      return t("feedback.header.title.plumber");

    if (serviceType === "Home Cleaning")
      return t("feedback.header.title.home_cleaning");

    return t("feedback.header.title.default");
  };

  const getHeaderDescription = () => {
    if (serviceType) {
      return t("feedback.header.description.withService", {
        serviceType,
      });
    }
    return t("feedback.header.description.default");
  };


  return (
    <section className="feedbackpage-section">
      <div className="feedbackpage-container">
        {/* Header */}
        <div className="feedbackpage-section-header">
          <h2 className="feedbackpage-section-title">{getHeaderTitle()}</h2>
          <p className="feedbackpage-section-description">
            {getHeaderDescription()}
          </p>
        </div>

        {/* Slider */}
        <div className="feedbackpage-testimonial-slider">
          <div
            className="feedbackpage-testimonial-track"
            style={{
              transform: `translateX(-${
                currentSlide * (100 / slidesPerView)
              }%)`,
            }}
          >
            {testimonials.map((t, i) => {
              const customerName =
                `${t.User?.FirstName || ""} ${t.User?.LastName || ""}`.trim() ||
                "Anonymous";
              const providerName = t.Servitor
                ? `${t.Servitor.FirstName} ${t.Servitor.LastName}`
                : "Service Provider";
              const serviceName =
                t.Services?.services_name || t.serviceType || "Service";

              return (
                <div key={i} className="feedbackpage-testimonial-slide">
                  <div
                    className="feedbackpage-testimonial-card feedbackpage-clickable-card"
                    onClick={() => openModal(t)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") openModal(t);
                    }}
                  >

                    {/* User Info */}
                    <div className="feedbackpage-testimonial-header">
                      <img
                        src={generateAvatar(customerName)}
                        alt={customerName}
                        className="feedbackpage-user-avatar"
                      />
                      <div className="feedbackpage-user-info">
                        <div className="feedbackpage-user-name-wrapper">
                          <h4 className="feedbackpage-user-name">
                            {customerName}
                          </h4>
                          {/* <i className="fas fa-check-circle feedbackpage-verified-icon"></i> */}
                          <FontAwesomeIcon icon={ICON.verified} className="feedbackpage-verified-icon" aria-hidden="true" />
                        </div>
                        {/* {t.User?.city && (
                          <div className="feedbackpage-user-location">
                            {t.User.city}
                          </div>
                        )} */}

                        <div className="feedbackpage-user-location">
                          {/* <i className="fas fa-map-marker-alt"></i> */}
                          <FontAwesomeIcon icon={ICON.location} aria-hidden="true" />

                          <span className="feedbackpage-location-text">
                            {t.User?.city || t.User?.area ? (
                              <>
                                {t.User?.city || ""}
                                {t.User?.city && t.User?.area ? ", " : ""}
                                {t.User?.area || ""}
                              </>
                            ) : (
                              "N/A"
                            )}
                          </span>
                        </div>


                        <div className="feedbackpage-rating-wrapper">
                          <div className="feedbackpage-stars">
                            {generateStars(t.rating)}
                          </div>
                        </div>
                        <div className="feedbackpage-review-date">
                          {formatDate(t.transactionDate)}
                        </div>
                      </div>
                    </div>

                    {/* Feedback Text */}
                    <p className="feedbackpage-feedback-text">"{t.feedback}"</p>

                    {/* Provider & Service */}
                    <div className="feedbackpage-testimonial-footer">
                      <div className="feedbackpage-provider-info">
                        <div
                          className={`feedbackpage-service-icon ${getServiceColor(
                            serviceName
                          )}`}
                        >
                          {/* <i className="fas fa-check"></i> */}
                          <FontAwesomeIcon icon={ICON.check} aria-hidden="true" />

                        </div>
                        <div className="feedbackpage-provider-details">
                          <div className="feedbackpage-provider-name">
                            {providerName}
                          </div>
                          <div className="feedbackpage-service-type">
                            {serviceName}
                          </div>
                        </div>
                      </div>
                      <div className="feedbackpage-rating-score">
                        <div className="feedbackpage-score">
                          {t.rating.toFixed(1)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Nav Arrows */}
          <button
            className="feedbackpage-nav-arrow feedbackpage-prev-arrow"
            onClick={prevSlide}
            disabled={currentSlide === 0}
          >
            {/* <i className="fas fa-chevron-left"></i> */}
            <FontAwesomeIcon icon={ICON.left} aria-hidden="true" />
          </button>
          <button
            className="feedbackpage-nav-arrow feedbackpage-next-arrow"
            onClick={nextSlide}
            disabled={currentSlide >= testimonials.length - slidesPerView}
          >
            {/* <i className="fas fa-chevron-right"></i> */}
            <FontAwesomeIcon icon={ICON.right} aria-hidden="true" />

          </button>
        </div>

        {/* Pagination Dots */}
        <div className="feedbackpage-slider-dots">
          {Array.from({ length: totalDots }).map((_, idx) => (
            <button
              key={idx}
              className={`feedbackpage-slider-dot ${
                Math.floor(currentSlide / slidesPerView) === idx
                  ? "feedbackpage-active"
                  : ""
              }`}
              onClick={() => goToSlide(idx)}
            />
          ))}
        </div>

        {/* Modal */}
        {isModalOpen && selectedTestimonial && (() => {
          const customerName =
            `${selectedTestimonial.User?.FirstName || ""} ${selectedTestimonial.User?.LastName || ""}`.trim() ||
            "Anonymous";

          const providerName = selectedTestimonial.Servitor
            ? `${selectedTestimonial.Servitor.FirstName} ${selectedTestimonial.Servitor.LastName}`
            : "Service Provider";

          const serviceName =
            selectedTestimonial.Services?.services_name ||
            selectedTestimonial.serviceType ||
            "Service";

          return (
            <div
              className="feedbackpage-modal-overlay"
              onClick={closeModal}
              role="dialog"
              aria-modal="true"
              aria-label="Feedback details"
            >
              <div
                className="feedbackpage-modal"
                onClick={(e) => e.stopPropagation()}
              >
                {/* Close */}
                <button
                  type="button"
                  className="feedbackpage-modal-close"
                  onClick={closeModal}
                  aria-label="Close"
                  title="Close"
                >
                  {/* <i className="fas fa-times" /> */}
                  <FontAwesomeIcon icon={ICON.close} aria-hidden="true" />
                </button>

                {/* Header */}
                <div className="feedbackpage-modal-header">
                  <img
                    src={generateAvatar(customerName)}
                    alt={customerName}
                    className="feedbackpage-modal-avatar"
                  />

                  <div className="feedbackpage-modal-header-info">
                    <div className="feedbackpage-modal-name-row">
                      <h3 className="feedbackpage-modal-name">{customerName}</h3>
                      {/* <i className="fas fa-check-circle feedbackpage-verified-icon"></i> */}
                      <FontAwesomeIcon icon={ICON.verified} className="feedbackpage-verified-icon" aria-hidden="true" />

                    </div>

                    {/* City + Date LEFT aligned (same line, responsive wraps) */}
                    <div className="feedbackpage-modal-meta">
                      {/* {selectedTestimonial.User?.city ? (
                        <span className="feedbackpage-modal-city">
                          <i className="fas fa-map-marker-alt"></i> {selectedTestimonial.User.city}
                        </span>
                      ) : (
                        <span className="feedbackpage-modal-city">
                          <i className="fas fa-map-marker-alt"></i> N/A
                        </span>
                      )} */}

                      <span className="feedbackpage-modal-city">
                        {/* <i className="fas fa-map-marker-alt"></i> */}
                        <FontAwesomeIcon icon={ICON.location} aria-hidden="true" />
                        <span className="feedbackpage-location-text">
                          {selectedTestimonial.User?.city || selectedTestimonial.User?.area ? (
                            <>
                              {selectedTestimonial.User?.city || ""}
                              {selectedTestimonial.User?.city && selectedTestimonial.User?.area ? ", " : ""}
                              {selectedTestimonial.User?.area || ""}
                            </>
                          ) : (
                            "N/A"
                          )}
                        </span>
                      </span>


                      <span className="feedbackpage-modal-date">
                        {/* <i className="far fa-clock"></i>  */}
                        <FontAwesomeIcon icon={ICON.clock} aria-hidden="true" />
                        {formatDate(selectedTestimonial.transactionDate)}
                      </span>
                    </div>

                    {/* Rating row */}
                    <div className="feedbackpage-modal-rating-row">
                      <div className="feedbackpage-stars">
                        {generateStars(selectedTestimonial.rating)}
                      </div>
                      <span className="feedbackpage-modal-score">
                        {Number(selectedTestimonial.rating).toFixed(1)}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Body (scrollable) */}
                <div className="feedbackpage-modal-body">
                  <p className="feedbackpage-modal-feedback">
                    “{selectedTestimonial.feedback}”
                  </p>
                </div>

                {/* Footer */}
                <div className="feedbackpage-modal-footer">
                  <div className="feedbackpage-provider-info">
                    <div
                      className={`feedbackpage-service-icon ${getServiceColor(serviceName)}`}
                    >
                      {/* <i className="fas fa-check"></i> */}
                      <FontAwesomeIcon icon={ICON.check} aria-hidden="true" />
                    </div>

                    <div className="feedbackpage-provider-details">
                      <div className="feedbackpage-provider-name">{providerName}</div>
                      <div className="feedbackpage-service-type">{serviceName}</div>
                    </div>
                  </div>

                  <div className="feedbackpage-modal-footer-score">
                    {Number(selectedTestimonial.rating).toFixed(1)}
                  </div>
                </div>
              </div>
            </div>
          );
        })()}
      </div>
    </section>
  );
};

export default FeedbackPage;

